import { type FC, type ReactNode } from 'react';

import styles from './PhotoContainerWrapper.scss';

const PhotoContainerWrapper: FC<{ children: ReactNode }> = ({ children }) => {
    return <div className={styles.wrapper}>{children}</div>;
};

export default PhotoContainerWrapper;
